import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["confirmation", "dialog", "form", "reset", "watch"]
  static values = { originalValues: Object, required: Boolean }

  choose(event) {
    if (this.hasConfirmationTarget) this.confirmationTarget.value = event.params.value
    this.confirmed = true
    try {
      this.dialogTarget.close("confirmed")
      this.formTarget.requestSubmit(this.submitter || undefined)
    } finally {
      this.confirmed = false
    }
  }

  close() {
    this.dialogTarget.close()
  }

  confirm(event) {
    if (this.confirmed) return
    this.updateRequired()
    if (!this.requiredValue) return

    event.preventDefault()
    this.submitter = event.submitter
    this.open()
  }

  connect() {
    this.dialogTarget.addEventListener("close", this.handleClose)
    this.updateRequired()
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener("close", this.handleClose)
      this.close()
    }
    document.body.classList.remove("overflow-hidden")
  }

  fieldValue({ field, original = false }) {
    const checkbox = field.type === "checkbox"
    const value = original
      ? (this.originalValuesValue[field.name] ??
        (checkbox ? field.defaultChecked : this.defaultValue(field)))
      : checkbox
        ? field.checked
        : field.value
    return field.type === "number" || field.inputMode === "decimal" ? Number(value) : value
  }

  defaultValue(field) {
    if (field.tagName !== "SELECT") return field.defaultValue
    return Array.from(field.options).find((option) => option.defaultSelected)?.value ?? ""
  }

  handleClose = () => {
    document.body.classList.remove("overflow-hidden")
    if (this.dialogTarget.returnValue === "confirmed") return

    for (const field of this.resetTargets) {
      const value = this.fieldValue({ field, original: true })
      if (field.type === "checkbox") field.checked = value
      else field.value = value
      field.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.updateRequired()
  }

  open() {
    this.dialogTarget.returnValue = ""
    document.body.classList.add("overflow-hidden")
    this.dialogTarget.showModal()
  }

  updateRequired() {
    if (this.hasConfirmationTarget) this.confirmationTarget.value = ""
    if (this.watchTargets.length === 0) return

    this.requiredValue = this.watchTargets.some(
      (field) => this.fieldValue({ field }) !== this.fieldValue({ field, original: true })
    )
  }
}
